import React from 'react'
import extractSpotifyEmbedUrl from '../../ui/SongPreview/util/extractSpotifyEmbedUrl'

const SpotifyEmbeddedPlaylistPreview = ({ url }) => {
  if(!url) {
    return null
  }

  const spotifyEmbedUrl = extractSpotifyEmbedUrl(url)
  if(!spotifyEmbedUrl) {
    return (
      <div>
        <p>Unable to load playlist. Please check the URL.</p>
      </div>
    )
  }

  return (
    <iframe
      style={{ borderRadius: 12 }}
      src={spotifyEmbedUrl}
      width="100%"
      height="450"
      frameBorder="0"
      allowFullScreen
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  )
}

export default SpotifyEmbeddedPlaylistPreview
